import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
export const MapControls = (props) => {
    const { mapMode, onDraw, onLocate } = props;
    const { t } = useTranslation('ponds');
    const isDrawing = mapMode === 'DRAWING';
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.75 }, children: [_jsx(Button, { variant: "contained", size: "small", startIcon: _jsx(AddIcon, {}), onClick: onDraw, disabled: isDrawing, sx: {
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 2,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.22)',
                    bgcolor: isDrawing ? 'primary.dark' : 'primary.main',
                    '&:hover': { bgcolor: 'primary.dark' },
                    '&.Mui-disabled': { bgcolor: 'primary.dark', color: 'rgba(255,255,255,0.7)' },
                    px: 1.5,
                }, children: t('addPond') }), _jsx(Tooltip, { title: t('map.myLocation'), placement: "left", children: _jsx(IconButton, { size: "small", onClick: onLocate, sx: {
                        bgcolor: 'rgba(255,255,255,0.94)',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.18)',
                        color: 'primary.main',
                        '&:hover': { bgcolor: 'white' },
                    }, children: _jsx(MyLocationIcon, { fontSize: "small" }) }) })] }));
};
